import '../../app.es6';
import angular from 'angular';
import moment from '../../../node_modules/moment/moment.js';

class AdminCourseListController {
  /* @ngInject */
  constructor (
    $rootScope, $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();
    let role = localStorage.getItem(this.Const.LSAPP_ROLE);
    if (role === this.Const.LSAPP_ROLE_MEMBER) {
      this.$location.path('/member');
    }

    // APIから取得したコースが存在している場合：true
    // APIから取得したコースが存在していない場合：false
    this.existenceFlg = true;

    // ゲスト動画からの遷移の場合、下部ボタンリストを表示しない
    this.showButtonList = this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] !== this.Const.ADMIN_COURSE_LIST_LOCATION.guestVideo;

    // staffは全クラス一覧ボタン押下から選択日付を持って遷移
    this.currentDate = this.$sessionStorage[this.Const.SSAPP_SELECTED_DATE] ? new Date(this.$sessionStorage[this.Const.SSAPP_SELECTED_DATE]) : new Date();
    // staff権限は当月、admin権限は前後三ヵ月を抽出Rangeとする
    if (role === this.Const.LSAPP_ROLE_STAFF) {
      this.monthRange = this.commonFactory.getMonthRange(this.currentDate);
      this.selectedYearMonth = moment(this.currentDate).format('YYYY年M月');
      this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
      Page.setTitle(this.Const.TITLE.courseListForStaff);
    } else {
      this.monthRange = this.commonFactory.getThreeMonthsBeforeAndAfter(this.currentDate);
      Page.setTitle(this.Const.TITLE.courseList);
    }
    this.getSchoolsSchoolIdCourses(this.monthRange.beginDateParam, this.monthRange.endDateParam);

    AdminCourseListController.$inject = ['$rootScope', '$scope',
                                        '$sessionStorage', '$location', 'commonApiFactory',
                                        'commonFactory', 'Const', 'Page'];
  }

  getSchoolsSchoolIdCourses (begin, end) {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }
    this.coursesParams = {
      schoolId: this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID],
      beginDateTime: begin,
      endDateTime: end
    };
    this.commonApiFactory.getAdminSchoolsSchoolIdCourses(this.coursesParams)
    .then((result) => {
      this.courseList = [];
      if (result.length === 0) {
        this.existenceFlg = false;
        this.commonFactory.overlayHidden();
        this.$scope.$apply();
        return;
      }
      result.forEach((course) => {
        let courseObj = {
          courseId: course.id,
          schoolId: course.schoolId,
          schoolName: this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME],
          courseName: course.name
        };
        this.courseList.push(courseObj);
      });
      this.$sessionStorage[this.Const.SSAPP_COURSE_LIST] = this.courseList;
      this.existenceFlg = true;
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      this.existenceFlg = false;
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
      console.log('error : ', error);
    });
  }

  // 基準からみて次の月に該当するコースを表示する
  toNextMonth () {
    let currentDate = this.currentDate;
    let nextMonthRange = this.commonFactory.getMonthLater(currentDate);
    // 次の月を基準とする
    this.currentDate = new Date(nextMonthRange.beginDateParam);
    this.selectedYearMonth = moment(this.currentDate).format('YYYY年M月');
    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
    this.getSchoolsSchoolIdCourses(nextMonthRange.beginDateParam, nextMonthRange.endDateParam);
  }

  // 基準からみて前の月に該当するコースを表示する
  toBeforeMonth () {
    let currentDate = this.currentDate;
    let beforeMonthRange = this.commonFactory.getMonthAgo(currentDate);
    // 前の月を基準とする
    this.currentDate = new Date(beforeMonthRange.beginDateParam);
    this.selectedYearMonth = moment(this.currentDate).format('YYYY年M月');
    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
    this.getSchoolsSchoolIdCourses(beforeMonthRange.beginDateParam, beforeMonthRange.endDateParam);
  }

  toCourseDetail (course, idx) {
    this.$sessionStorage[this.Const.SSAPP_COURSE_INDEX] = idx;
    this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = course.schoolName;
    // 次の画面でコースを受講している生徒を取得するために必要
    this.$sessionStorage[this.Const.SSAPP_COURSE_ID] = course.courseId;
    this.$location.path('/staff/course');
  }

  toGuestVideoList () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/staff/guest_video');
  }
  toVideoBacklog () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/staff/video_backlog');
  }
}

angular.module('myApp').controller('AdminCourseListController', AdminCourseListController);



// WEBPACK FOOTER //
// ./app/components/admin-course-list/admin-course-list-controller.es6